var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html, LitElement } from 'lit';
import { map } from 'lit-html/directives/map.js';
import { property, state } from 'lit/decorators.js';
import { isNil } from 'lodash-es';
import { isTreeViewNode, pathToRootsGrandchild, } from '../services/hierarchical-tree-state-service';
import { NodePositioningService } from '../services/node-positioning-service';
import { findTree } from './utilities';
/**
 * Class that contains the base functionality for a tree node.
 */
let SdsTreeNodeBase = (() => {
    var _a, _SdsTreeNodeBase_isCollapsed_accessor_storage, _SdsTreeNodeBase_frozenColumns_accessor_storage, _SdsTreeNodeBase_columns_accessor_storage, _SdsTreeNodeBase_documentDir_accessor_storage, _SdsTreeNodeBase_level_accessor_storage;
    let _classSuper = LitElement;
    let _isCollapsed_decorators;
    let _isCollapsed_initializers = [];
    let _isCollapsed_extraInitializers = [];
    let _frozenColumns_decorators;
    let _frozenColumns_initializers = [];
    let _frozenColumns_extraInitializers = [];
    let _columns_decorators;
    let _columns_initializers = [];
    let _columns_extraInitializers = [];
    let _documentDir_decorators;
    let _documentDir_initializers = [];
    let _documentDir_extraInitializers = [];
    let _level_decorators;
    let _level_initializers = [];
    let _level_extraInitializers = [];
    return _a = class SdsTreeNodeBase extends _classSuper {
            constructor() {
                super(...arguments);
                _SdsTreeNodeBase_isCollapsed_accessor_storage.set(this, __runInitializers(this, _isCollapsed_initializers, false));
                _SdsTreeNodeBase_frozenColumns_accessor_storage.set(this, (__runInitializers(this, _isCollapsed_extraInitializers), __runInitializers(this, _frozenColumns_initializers, 0)));
                /**
                 * True if node is the leaf node, meaning it has no children.
                 * @protected
                 */
                this._isLeaf = (__runInitializers(this, _frozenColumns_extraInitializers), false);
                _SdsTreeNodeBase_columns_accessor_storage.set(this, __runInitializers(this, _columns_initializers, 0));
                _SdsTreeNodeBase_documentDir_accessor_storage.set(this, (__runInitializers(this, _columns_extraInitializers), __runInitializers(this, _documentDir_initializers, 'ltr')));
                _SdsTreeNodeBase_level_accessor_storage.set(this, (__runInitializers(this, _documentDir_extraInitializers), __runInitializers(this, _level_initializers, 1)));
                this.childNodeIds = (__runInitializers(this, _level_extraInitializers), new Set());
                /**
                 * Instance of the NodePositioningService class.
                 */
                this.paddingService = new NodePositioningService();
                /**
                 * The node ID.
                 */
                this._nodeId = undefined;
                /**
                 * A promise that resolves when the node is ready.
                 */
                this.nodeIsReady = new Promise((resolve, reject) => {
                    this.resolveReady = resolve;
                    this.rejectReady = reject;
                });
                this.parentNodeId = undefined;
                this.handleDocumentDirChange = (dir) => {
                    this.documentDir = dir;
                };
                this.childAdditionHandler = (nodeId) => {
                    this.childNodeIds.add(nodeId);
                    this.childAddedCallback(nodeId);
                };
                this.childRemovalHandler = (node) => {
                    var _b;
                    if (((_b = node.parent) === null || _b === void 0 ? void 0 : _b.id) === this.nodeId) {
                        this.childNodeIds.delete(node.id);
                        this.childRemovedCallback(node.id);
                    }
                };
                this.handleFrozenColumnsChange = (value) => {
                    this.changeFrozenColumns(value);
                };
                this.handleColumnCountChange = (value) => {
                    this.columns = value;
                };
            }
            /**
             * True if node is collapsed.
             */
            get isCollapsed() { return __classPrivateFieldGet(this, _SdsTreeNodeBase_isCollapsed_accessor_storage, "f"); }
            set isCollapsed(value) { __classPrivateFieldSet(this, _SdsTreeNodeBase_isCollapsed_accessor_storage, value, "f"); }
            /**
             * Number of frozen columns in the tree.
             */
            get frozenColumns() { return __classPrivateFieldGet(this, _SdsTreeNodeBase_frozenColumns_accessor_storage, "f"); }
            set frozenColumns(value) { __classPrivateFieldSet(this, _SdsTreeNodeBase_frozenColumns_accessor_storage, value, "f"); }
            /**
             * The number of columns for the tree node.
             */
            get columns() { return __classPrivateFieldGet(this, _SdsTreeNodeBase_columns_accessor_storage, "f"); }
            set columns(value) { __classPrivateFieldSet(this, _SdsTreeNodeBase_columns_accessor_storage, value, "f"); }
            /**
             * The document direction, either 'ltr' or 'rtl'.
             */
            get documentDir() { return __classPrivateFieldGet(this, _SdsTreeNodeBase_documentDir_accessor_storage, "f"); }
            set documentDir(value) { __classPrivateFieldSet(this, _SdsTreeNodeBase_documentDir_accessor_storage, value, "f"); }
            /**
             * Level of the node in the tree.
             */
            get level() { return __classPrivateFieldGet(this, _SdsTreeNodeBase_level_accessor_storage, "f"); }
            set level(value) { __classPrivateFieldSet(this, _SdsTreeNodeBase_level_accessor_storage, value, "f"); }
            /**
             * Get the node ID.
             * @returns {string | undefined} The node ID.
             */
            get nodeId() {
                return this._nodeId;
            }
            set nodeId(value) {
                const oldValue = this._nodeId;
                this._nodeId = value;
                this.requestUpdate('nodeId', oldValue);
            }
            /**
             * Get whether the node is a leaf node.
             * @returns {boolean} True if the node is a leaf node, false otherwise.
             */
            get isLeaf() {
                return this._isLeaf;
            }
            /**
             * Set whether the node is a leaf node.
             * @param {boolean} value The value to set for isLeaf.
             */
            set isLeaf(value) {
                const oldValue = this._isLeaf;
                this._isLeaf = value;
                this.requestUpdate('isLeaf', oldValue);
            }
            /**
             * Get the tree that the node belongs to.
             * @returns {SdsTree | undefined} The tree that the node belongs to.
             */
            get tree() {
                return this._tree;
            }
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            nodeOrderInView(_node) {
                throw new Error('This type of node does not support this operation');
            }
            /**
             * Set the level of the node in the tree using parents level.
             * @param parentLvl
             */
            updateLevelByParent(parentLvl) {
                const newLevel = parentLvl + 1;
                if (this.level !== newLevel) {
                    this.level = newLevel;
                }
            }
            async connectedCallback() {
                var _b, _c;
                super.connectedCallback();
                this._tree = findTree(this);
                await this.registerNodeInHierarchicalState(this.findParent());
                this.addStateListener('documentDirection', this.handleDocumentDirChange);
                this.addStateListener('frozenColumnCount', this.handleFrozenColumnsChange);
                this.addStateListener('columnCount', this.handleColumnCountChange);
                if (!isNil(this.nodeId)) {
                    (_b = this.tree) === null || _b === void 0 ? void 0 : _b.hierarchicalState.addChildAdditionListener(this.nodeId, this.childAdditionHandler);
                }
                (_c = this.tree) === null || _c === void 0 ? void 0 : _c.hierarchicalState.addNodeRemovalListener(this.childRemovalHandler, true);
            }
            addStateListener(event, listener) {
                var _b, _c, _d;
                if (!((_b = this.tree) === null || _b === void 0 ? void 0 : _b.state.hasListener(event, listener))) {
                    (_d = (_c = this.tree) === null || _c === void 0 ? void 0 : _c.state) === null || _d === void 0 ? void 0 : _d.addListener(event, listener);
                }
            }
            disconnectedCallback() {
                var _b, _c, _d, _e, _f, _g, _h;
                super.disconnectedCallback();
                if (this.tree !== undefined && this.nodeId !== undefined) {
                    this.tree.hierarchicalState.removeChildAdditionListener(this.nodeId, this.childAdditionHandler);
                    this.tree.hierarchicalState.removeNode(this.nodeId);
                }
                (_c = (_b = this.tree) === null || _b === void 0 ? void 0 : _b.state) === null || _c === void 0 ? void 0 : _c.removeListener('documentDirection', this.handleDocumentDirChange);
                (_e = (_d = this.tree) === null || _d === void 0 ? void 0 : _d.state) === null || _e === void 0 ? void 0 : _e.removeListener('frozenColumnCount', this.handleFrozenColumnsChange);
                (_g = (_f = this.tree) === null || _f === void 0 ? void 0 : _f.state) === null || _g === void 0 ? void 0 : _g.removeListener('columnCount', this.handleColumnCountChange);
                (_h = this.tree) === null || _h === void 0 ? void 0 : _h.hierarchicalState.removeNodeRemovalListener(this.childRemovalHandler);
                delete this._tree;
            }
            /**
             * Update the number of frozen columns in the tree node.
             * @param {number} newValue The new value for the number of frozen columns.
             */
            changeFrozenColumns(newValue) {
                this.frozenColumns = newValue;
            }
            /**
             * Render the single path for the tree node.
             * @param {boolean} isCollapsed Whether the node is collapsed.
             * @param {boolean} isLeaf Whether the node is a leaf node.
             * @returns {TemplateResult<1>} The rendered single path.
             */
            renderSinglePath(isCollapsed, isLeaf) {
                if (!isLeaf) {
                    return html `
                <div class="sds-tree-inner-column"></div>
                <div name="path" class="sds-tree-path sds-tree-inner-column">
                    <span class="sds-tree-path__inner"></span>
                </div>
            `;
                }
                else {
                    return html ` <div class="sds-tree-inner-column"></div>
                <div class="sds-tree-inner-column"></div>`;
                }
            }
            /**
             * Render the passing paths for the tree node.
             * @param {TreeNode | undefined} treeNode The tree node for rendering.
             * @returns {TemplateResult<1> | undefined} The rendered passing paths.
             */
            renderPassingPaths(treeNode) {
                if (treeNode !== undefined) {
                    return html `
                <div
                    name="path"
                    class="sds-tree-inner-column sds-tree-border sds-tree-border--left"
                >
                    ${map(pathToRootsGrandchild(treeNode), treeNode => {
                        return html `
                            <span
                                class="sds-tree-border__inner sds-tree-border__inner--left"
                                style="${treeNode.isLastChild ? 'opacity: 0;' : ''}"
                            ></span>
                        `;
                    })}
                </div>
            `;
                }
                else {
                    return undefined;
                }
            }
            /**
             * Render the path end for the tree node.
             * @param {boolean} isLeaf Whether the node is a leaf node.
             * @param {boolean} isCollapsed Whether the node is collapsed.
             * @returns {TemplateResult<1>} The rendered path end.
             */
            renderPathEnd(isLeaf, isCollapsed) {
                return html `
            <div name="path" class="sds-tree-inner-column sds-tree-border sds-tree-border--right">
                <span class="sds-tree-border__inner sds-tree-border__inner--left"></span>
                <span class="sds-tree-border__inner sds-tree-border__inner--right"></span>
                ${isLeaf || isCollapsed
                    ? undefined
                    : html `
                          <span class="sds-tree-border__inner sds-tree-border__inner--top"></span>
                      `}
            </div>
        `;
            }
            /**
             * Generate path styles for the tree node.
             * @param {number} level The level of the tree node.
             * @param {'ltr' | 'rtl'} dir The document direction.
             * @returns {TemplateResult<1>} The path styles.
             */
            pathStyles(level, dir) {
                // prettier-ignore
                return html `
            <style>
                .sds-tree-border--right {
                    width: ${this.paddingService.calculatePathStageRight(level)}px;
                }

                .sds-tree-border--left {
                    width: ${this.paddingService.calculatePathStageLeft(level)}px;
                }

                .sds-tree-border__inner--top {
                    ${dir === 'ltr' ? 'left' :
                    'right'}: ${this.paddingService.calculateOutgoingPathPosition(level)}px;
                }

            </style>
        `;
            }
            /**
             * Generate level styles for the tree node.
             * @param {number} level The level of the tree node.
             * @param {'ltr' | 'rtl'} dir The document direction.
             * @param {number} frozenColumns The number of frozen columns.
             * @param isLeaf Meaning node has no children
             * @returns {TemplateResult<1>} The level styles.
             */
            levelStyles(level, dir, frozenColumns, isLeaf) {
                if (isLeaf && level === 1) {
                    return html ``;
                }
                const dirName = dir === 'ltr' ? 'left' : 'right';
                const controlPadding = this.paddingService.calculateControlPadding(level);
                // prettier-ignore
                return html `
            <style>
                :host ::slotted(:not(sds-tree-cell-skeleton):first-child) {
                    padding-${dirName}: ${this.paddingService.calculateContentPadding(level)}px !important;
                }

                .sds-tree__action, .sds-tree__icon {
                    ${dirName}: ${controlPadding}px;
                    ${frozenColumns !== 0 ?
                    ` margin-${dirName}: ${controlPadding}px;`
                    : undefined}
                }
            </style>
        `;
            }
            /**
             * Get the child count for the tree node.
             * @returns {number | undefined} The number of children for the tree node, or undefined if not applicable.
             */
            getChildCount() {
                return undefined;
            }
            // eslint-disable-next-line @typescript-eslint/no-empty-function,@typescript-eslint/no-unused-vars
            childAddedCallback(childId) { }
            // eslint-disable-next-line @typescript-eslint/no-empty-function,@typescript-eslint/no-unused-vars
            childRemovedCallback(childId) { }
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            nodeRegisteredCallback() { }
            findParent() {
                if (this.isConnected) {
                    const parent = this.parentElement;
                    if (isNil(parent)) {
                        console.error('Tree node is not inside a tree or another tree node');
                        return undefined;
                    }
                    else {
                        if (isTreeViewNode(parent)) {
                            return parent;
                        }
                        else {
                            console.error('Tree node is not inside a tree or another tree node');
                            return undefined;
                        }
                    }
                }
                else {
                    console.warn('Tree node is not yet connected to the DOM');
                    return undefined;
                }
            }
            async registerNodeInHierarchicalState(parent) {
                var _b;
                if (!isNil(parent)) {
                    await parent.nodeIsReady;
                    this.parentNodeId = parent.nodeId;
                    if (!isNil(this.parentNodeId)) {
                        this.nodeId = (_b = this.tree) === null || _b === void 0 ? void 0 : _b.hierarchicalState.addNode(this.parentNodeId, {
                            orderIndex: () => parent.nodeOrderInView(this),
                            childCount: this.getChildCount(),
                        });
                        this.nodeRegisteredCallback();
                        this.resolveReady();
                    }
                }
            }
        },
        _SdsTreeNodeBase_isCollapsed_accessor_storage = new WeakMap(),
        _SdsTreeNodeBase_frozenColumns_accessor_storage = new WeakMap(),
        _SdsTreeNodeBase_columns_accessor_storage = new WeakMap(),
        _SdsTreeNodeBase_documentDir_accessor_storage = new WeakMap(),
        _SdsTreeNodeBase_level_accessor_storage = new WeakMap(),
        (() => {
            var _b;
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
            _isCollapsed_decorators = [property({ type: Boolean, attribute: 'collapsed', reflect: true })];
            _frozenColumns_decorators = [property({ attribute: 'frozen-columns', type: Number, reflect: true })];
            _columns_decorators = [state()];
            _documentDir_decorators = [state()];
            _level_decorators = [property({ type: Number, attribute: 'level', reflect: true })];
            __esDecorate(_a, null, _isCollapsed_decorators, { kind: "accessor", name: "isCollapsed", static: false, private: false, access: { has: obj => "isCollapsed" in obj, get: obj => obj.isCollapsed, set: (obj, value) => { obj.isCollapsed = value; } }, metadata: _metadata }, _isCollapsed_initializers, _isCollapsed_extraInitializers);
            __esDecorate(_a, null, _frozenColumns_decorators, { kind: "accessor", name: "frozenColumns", static: false, private: false, access: { has: obj => "frozenColumns" in obj, get: obj => obj.frozenColumns, set: (obj, value) => { obj.frozenColumns = value; } }, metadata: _metadata }, _frozenColumns_initializers, _frozenColumns_extraInitializers);
            __esDecorate(_a, null, _columns_decorators, { kind: "accessor", name: "columns", static: false, private: false, access: { has: obj => "columns" in obj, get: obj => obj.columns, set: (obj, value) => { obj.columns = value; } }, metadata: _metadata }, _columns_initializers, _columns_extraInitializers);
            __esDecorate(_a, null, _documentDir_decorators, { kind: "accessor", name: "documentDir", static: false, private: false, access: { has: obj => "documentDir" in obj, get: obj => obj.documentDir, set: (obj, value) => { obj.documentDir = value; } }, metadata: _metadata }, _documentDir_initializers, _documentDir_extraInitializers);
            __esDecorate(_a, null, _level_decorators, { kind: "accessor", name: "level", static: false, private: false, access: { has: obj => "level" in obj, get: obj => obj.level, set: (obj, value) => { obj.level = value; } }, metadata: _metadata }, _level_initializers, _level_extraInitializers);
            if (_metadata) Object.defineProperty(_a, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
        })(),
        _a;
})();
export { SdsTreeNodeBase };
